import {Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {filter, map} from "rxjs/operators";

const NagerUrl = 'https://date.nager.at/api/v3/PublicHolidays/2025/us';

@Injectable({providedIn: 'root'})
export class HolidaysService {


    constructor(private readonly _httpClient: HttpClient) {
    }

    private _holidays: string[] = [];

    async init(): Promise<void> {
        // const data = await this._httpClient.get<any[]>(NagerUrl)
        //     .toPromise<any[]>();
        //
        // const dates = data
        //     .filter(x => x.types && x.types.indexOf('Public')>=0)
        //     .map((item: any) => item.date);

        this._holidays = [
            "2025-05-26",
            "2025-06-19",
            "2025-07-04",
            "2025-09-01",
            "2025-11-27",
            "2025-12-25"
        ];
    }

    isHoliday(strDate: string) {
        return this._holidays.indexOf(strDate) >= 0;
    }
}